module.exports = __webpack_public_path__ + "static/media/Meganium_gaussian2.a4d27f00.png";